module.exports = __webpack_public_path__ + "img/icon_beautyfashion.65fb3a0.svg";